// extracted by mini-css-extract-plugin
export default {"root":"Article_root__8EOSO","title":"Article_title__oLMWQ","middle":"Article_middle__T8hPN","ul":"Article_ul__cYYpD","li":"Article_li__W8z3o"};